import diacritics from 'diacritics';

export const getOnlyAlphaNums = (string) => {
  if (string) {
    return diacritics.remove(string)?.replace(/[^a-z0-9]/gi, '').trim();
  }

  return string;
};
